
import Slider from "react-slick";
import { upcomingCollectionsSettings, newCollectionsSettings, auctionSettings } from "./SliderSettings";
import './Home.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import collectionsData2 from "../../collectionsData";
import UpcomingCollectionCard from "../../components/UpcomingCollectionCard/UpcomingCollectionCard";
import NewCollectionCard from '../../components/NewCollectionCard/NewCollectionCard';
// import CollectionCard from "../../components/CollectionCard/CollectionCard";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import LaunchpadDropsCard from "../../components/LaunchpadDropsCard/LaunchpadDropsCard";
import { rankingStats, auctions } from "../../collectionsData";
import { useState } from "react";
import RankingStatsCard from "../../components/RankingStatsCard/RankingStatsCard";
import AuctionCard from '../../components/AuctionCard/AuctionCard';



const Home = () => { 
 
  const [launchpadFilter, setLaunchpadFilter] = useState(['', 'active']);
  const [popularFilter, setPopularFilter] = useState(['active', '', '', '']);
  const [auctionFilter, setAuctionFilter] = useState(['active', '', '', '']);

  const changeLaunchPadFilter = (index) => {
    let temparr = ['', ''];
    temparr[index] = 'active';
    setLaunchpadFilter(temparr);
  }

  const changePopularFilter = (index) => {
    let temparr = ['', '', '', ''];
    temparr[index] = 'active';
    setPopularFilter(temparr);
  }

  const changeAuctionFilter = (index) => {
    let temparr = ['', '', '', ''];
    temparr[index] = 'active';
    setAuctionFilter(temparr);
  }

  return (
    <div className="bg-[white] dark:bg-dark-content-bg dark:text-white px-[5vw] md:px-10  transition-colors duration-300 ease-in-out">

      <div className="max-w-[1248px] mx-auto">

        <div className="flex flex-col md:flex-row items-center justify-center home_cover pt-10">
          <div className='flex flex-col mb-10 md:mb-0 md:w-[49%] md:mr-[5%]'>
            <h1 className='mb-2 w-fit text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold max-w-[15ch] '>
              <span className = 'text-main'>X-Market</span>
            </h1>
            <p className='max-w-[40ch] text-xl 2xl:text-2xl leading-36px text-slate-400 mb-8'>
              X market is a marketplace on the Protocol Near. You can buy and sell the most premium NFT's from Near. Home for all digital art fans!
            </p>
            <PrimaryButton title={'Explore Collections'} href = '/collections'/>
          </div>
          <div className="flex relative md:w-[46%]">
            <div className="flex flex-col items-end">
              <img src = 'https://media.giphy.com/media/ho0xXatV7b3Fo1ZRXN/giphy.gif' alt = 'home-cover' className = 'w-[90%] m-4'/>
              <img src = 'https://media.giphy.com/media/M52wyuahvQfJK/giphy.gif' alt = 'home-cover' className = 'w-[80%] m-4'/>
            </div>
            <div className="flex flex-col items-start relative bottom-[-30px]">
              <img src = 'https://media.giphy.com/media/jQb5vQCpxZk6WgrB3z/giphy.gif' alt = 'home-cover' className = 'w-[70%] h-[50%] m-4'/>
              <img src = 'https://media.giphy.com/media/IiuZjA4RQUKIf5TbMi/giphy-downsized-large.gif' alt = 'home-cover' className = 'w-[90%] m-4'/>
            </div>
          </div>

        </div>
      
      </div>

      <div className="max-w-[1400px] mx-auto">

        <div className="mt-20">
            <div className="flex flex-col sm:flex-row mb-10 items-start sm:items-center">
              <h1 className='mr-5 mb-5 sm:mb-0 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                Launchpad Drops
              </h1>
              <div className="flex border-gray-300 dark:border-gray-700 border-[1px] rounded-[20px]">
                <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[130px] ${launchpadFilter[0] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeLaunchPadFilter(0)}>Next 7 days</button>
                <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[130px] ${launchpadFilter[1] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeLaunchPadFilter(1)}>Comming Soon</button>
              </div>
            </div>
            <div className="flex">
              {collectionsData2.map((collection, index) => {
                if(index < 3){
                  return (
                    <LaunchpadDropsCard collection={collection}/>
                  )
                }
                else{
                  return null;
                }
              })}
            </div>
         

        </div>


        <div className="mt-20">
          <div className="flex flex-col sm:flex-row mb-10 items-start sm:items-center">
            <h1 className='mr-5 mb-5 sm:mb-0 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
              Popular Collections
            </h1>
            <div className="flex border-gray-300 dark:border-gray-700 border-[1px] rounded-[20px]">
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${popularFilter[0] === 'active' && 'text-white bg-main'}`} onClick = {()=>changePopularFilter(0)}>24 hrs</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${popularFilter[1] === 'active' && 'text-white bg-main'}`} onClick = {()=>changePopularFilter(1)}>7 days</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${popularFilter[2] === 'active' && 'text-white bg-main'}`} onClick = {()=>changePopularFilter(2)}>30 days</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${popularFilter[3] === 'active' && 'text-white bg-main'}`} onClick = {()=>changePopularFilter(3)}>All time</button>
            </div>
          </div>
          <Slider {...upcomingCollectionsSettings}>
            {collectionsData2.map((collection, index) => {
              if(index < 6){
                return (
                  <UpcomingCollectionCard collection={collection} />
                )
              }
              else{
                return null;
              }
            })}
          </Slider>

        </div>

        <div className="my-20">

          <h1 className='text-2xl lg:text-3xl font-bold text-center mt-10 mb-10'>Top Collection Over <span className='text-main'>last 7 Days</span></h1>

          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-1 md:gap-y-5 mb-5'>
              {rankingStats.map((collection, index) => {
                if(index < 9){
                  return <RankingStatsCard collection = {collection} number = {index} />
                }
                else return null;
                  
              })}
              
              
          </div>

          <div className='w-full flex justify-center'>
              <PrimaryButton title = {'Go to Rankings'} className={'mt-8 lg:mt-16'} href = {'/rankings'} />
          </div>


        </div>

        <div className="mt-20">
            <h1 className='secondary_heading mb-10 leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
              New Collections
            </h1>
          <Slider {...newCollectionsSettings}>
            {collectionsData2.map((collection, index) => {
              if(index > 10){
                return (
                  <NewCollectionCard collection={collection} />
                )
              }
              else{
                return null;
              }
            })}
          </Slider>

        </div>
        

        <div className="my-20">
          <div className="flex flex-col sm:flex-row mb-10 items-start sm:items-center">
            <h1 className='mr-5 mb-5 sm:mb-0 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
              Auctions
            </h1>
            <div className="flex border-gray-300 dark:border-gray-700 border-[1px] rounded-[20px]">
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${auctionFilter[0] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeAuctionFilter(0)}>24 hrs</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${auctionFilter[1] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeAuctionFilter(1)}>7 days</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${auctionFilter[2] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeAuctionFilter(2)}>30 days</button>
              <button className={`py-2 px-4 text-[12px] rounded-[20px] w-[80px] ${auctionFilter[3] === 'active' && 'text-white bg-main'}`} onClick = {()=>changeAuctionFilter(3)}>All time</button>
            </div>
          </div>
          <Slider {...auctionSettings}>
            {auctions.map((auction, index) => {
              if(index < 8){
                return (
                  <AuctionCard auction={auction} />
                )
              }
              else{
                return null;
              }
            })}
          </Slider>

        </div>


        {/* <div className="my-20">
            <h1 className='secondary_heading mb-10 leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
              All Collections
            </h1>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-6">
                {collectionsData2.map((collection, index) => {
                  if(index < 30){
                    return(
                        <CollectionCard collection = {collection} />
                    )
                  }
                  else return null;
                })}
            </div>

        </div> */}

        


      </div>

    </div>
  );
};

export default Home;